export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Black.21e53471.jpg";